// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__XBwQj","image":"Avatar_image__txssE","live-avatar-border":"Avatar_live-avatar-border__4MzCc"};